import { routers } from '@/components/Router/router.config';
declare var abp: any;

// 获取标题
export const getPageTitle = (pathname: string) => {
  const route = routers.filter((route: any) => route.path === pathname);
  return route[0]?.title || '一体化手机框架';
};
export const getUrlVal = (para: any, searchStr?: string) => {
  var search = searchStr || window.location.search; //页面URL的查询部分字符串
  var arrPara = new Array(); //参数数组。数组单项为包含参数名和参数值的字符串，如“para=value”
  var arrVal = new Array(); //参数值数组。用于存储查找到的参数值

  if (search != "") {
    var index = 0;
    search = search.substr(1); //去除开头的“?”
    arrPara = search.split("&");

    for (let i in arrPara) {
      var paraPre = para + "="; //参数前缀。即参数名+“=”，如“para=”
      if (arrPara[i].indexOf(paraPre) == 0 && paraPre.length < arrPara[i].length) {
        arrVal[index] = decodeURI(arrPara[i].substr(paraPre.length)); //顺带URI解码避免出现乱码
        index++;
      }
    }
  }

  if (arrVal.length == 1) {
    return arrVal[0];
  } else if (arrVal.length == 0) {
    return null;
  } else {
    return arrVal;
  }
}
export const dateFtt = (fmt: string, date: Date) => { //author: meizz 
  var o: any = {
    "M+": date.getMonth() + 1,     //月份 
    "d+": date.getDate(),     //日 
    "h+": date.getHours(),     //小时 
    "m+": date.getMinutes(),     //分 
    "s+": date.getSeconds(),     //秒 
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
    "S": date.getMilliseconds()    //毫秒 
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}
export const os = (() => {
  var isLandscape = false;//是否横屏
  if (window.orientation === 180 || window.orientation === 0) {
    //竖屏
  }
  if (window.orientation === 90 || window.orientation === -90) {
    //横屏
    isLandscape = true;
  }
  var ua = navigator.userAgent,
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isChrome = /(?:Chrome|CriOS)/.test(ua),
    isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet )/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isSymbian,
    isIos = /(iphone|ipad|ipod|mac)/gi.test(navigator.appVersion.toLocaleLowerCase());


  return {
    isTablet: isTablet,
    isPhone: isPhone,
    isAndroid: isAndroid,
    isPc: isPc,
    isIos: isIos,
    isIpadPortrait: isTablet && !isLandscape && isIos,
    isIpadLandscape: isTablet && isLandscape && isIos
  };
})()